import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { MenuItemDto } from '../../../../services/menu/dto/api-response-dto';
import { CurrencyPipe } from '../../../../pipes/currency.pipe';

@Component({
  selector: 'app-featured-items',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './featured-items.component.html',
  styleUrl: './featured-items.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturedItemsComponent implements AfterViewInit {
  @Input() items: MenuItemDto[] = [];
  @Output() itemClick = new EventEmitter<MenuItemDto>();
  @ViewChild('swiperEl') swiperEl!: ElementRef;

  ngAfterViewInit(): void {
    const swiper = this.swiperEl.nativeElement;
    Object.assign(swiper, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: { clickable: true },
    });
    swiper.initialize();
  }
}
